<div class="sos-content">
    <div>
        <h4>Documentos</h4>
        <app-upload-arquivos-multiavalistas
        [origem]="proposta.grupo2 === 'MICROCRÉDITO-RL' ? 14 : 9"
        [isOrigemSos]="true"
        [documentos]="documentos"
        [idFicha]="proposta.id"
        [cliente]="proposta.cliente"
        [cpfAvalistas]="cpfAvalistas">
      </app-upload-arquivos-multiavalistas>

</div>
